// extracted by mini-css-extract-plugin
module.exports = {"csrWhy":"TOymY2mpnVob4rQVbbqXR"};